// src/redux/store.ts

import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { operationListenerMiddleware } from './api/operations/operationListener';

export const store = configureStore({
    reducer: rootReducer,
    // Redux Toolkit автоматически добавляет middleware, включая thunk и DevTools
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().prepend(operationListenerMiddleware.middleware),

});

// Типы для dispatch и состояния
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
